import { Badge } from "@/components/ui/badge"

export const TableBadge = ({ value }: { value: string | number }) => {
  return (
    <Badge className="bg-surface-subdued text-on-surface-subdued" variant="destructive" data-testid="count">
      {value}
    </Badge>
  )
}
